import { email as emailRegex } from 'utils/regex';

export const isEmail = email => emailRegex.test(email);
